import { render, staticRenderFns } from "./CategoryContacts.vue?vue&type=template&id=2dbcc9ee&scoped=true"
import script from "./CategoryContacts.vue?vue&type=script&lang=js"
export * from "./CategoryContacts.vue?vue&type=script&lang=js"
import style0 from "./CategoryContacts.vue?vue&type=style&index=0&id=2dbcc9ee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbcc9ee",
  null
  
)

export default component.exports